import React, { useEffect, useState } from "react";
import { URLS } from "../urls";
import moment from "moment";
import { Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import CurrencyInput from "react-currency-input-field";
import { fetchActionsUtil, useCookie } from "../../utils";
import ModalLoader from "../ModalLoader";

export default function ApplyLoanModal({ onHide, show, refresh }) {
  const branch_id = useCookie("branch_id");

  const [state, setState] = useState({
    buttonText: "Submit",
    isWaiting: false,
    isLoading: false,
    Amount: 0,
    userId: "",
    applyDate: moment(new Date()).format("DD/MM/YYYY"),
    staff: "",
    departments: [],
    users: [],
    comment: "",
    appliedDate: "",
    title: "",
    description: "",
    employee: {},
    employees: [],
    supervisor: null,
    requester: null,
  });

  const componentDidMount = async () => {
    if (process.env.REACT_APP_HAS_INVEX !== "true") {
      return toast.error("Please activate accountant module to use Loan");
    }

    const token = "dummy token";

    const departmentData = fetchActionsUtil(
      `${URLS.mainSiteBackend}/users/departments`,
      "GET",
      token
    );

    const employeeData = fetchActionsUtil(
      `${URLS.backendEmployees}/get/${branch_id}`,
      "GET",
      token
    );

    const [departmentResult, employeeResult] = await Promise.all([
      departmentData,
      employeeData,
    ]);

    const res = departmentResult?.data?.departments?.map((el) => ({
      value: el?.Department,
      label: el?.Department,
    }));

    const emp = employeeResult?.employees.map((em) => ({
      label: `${em.personalInfo.name.first || ""} ${
        em.personalInfo.name.middle || ""
      } ${em.personalInfo.name.last || ""}`,
      value: JSON.stringify({
        id: em._id,
        name: `${em.personalInfo.name.first || ""} ${
          em.personalInfo.name.middle || ""
        } ${em.personalInfo.name.last || ""}`,
      }),
    }));

    setState((el) => ({
      ...el,
      departments: [
        { value: "", label: "Select Recipient's Department" },
        ...res,
      ],
      employees: emp,
    }));

    // getDepartments();
    // getEmployees();
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      componentDidMount();
    }

    return () => {
      isMounted = false;
    };
  }, [branch_id]);

  const getSupervisors = async (id) => {
    try {
      setState((el) => ({ ...el, isLoading: true }));
      let response = await fetch(
        `${URLS.backendEmployees}/getOneEmployeeSupervisor/${id}`,
        {
          method: "GET",
          headers: {
            Accept: "Application/json",
            "Content-Type": "Application/json",
          },
          // credentials: "include",
        }
      );

      if (!response.ok) {
        response = await response.json();
        throw new Error(response.message);
      }
      const { foundSupervisor } = await response.json();

      if (foundSupervisor) {
        if (process.env.REACT_APP_HAS_INVEX === "true") {
          let response = await fetch(
            `${URLS.mainSiteBackend}/users/${foundSupervisor?.Staff_ID}`,
            {
              method: "GET",
              headers: {
                Accept: "Application/json",
                "Content-Type": "Application/json",
              },
              // credentials: "include",
            }
          );

          if (!response.ok) {
            response = await response.json();

            throw new Error(response.message);
          }

          const { data } = await response.json();

          setState((el) => ({
            ...el,
            supervisor: data,
            staff: data?.Staff_ID,
          }));
        }
      } else {
        setState((el) => ({
          ...el,
          supervisor: null,
          staff: "",
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setState((el) => ({ ...el, isLoading: false }));
    }
  };

  const getUsersInDepartments = async (department) => {
    let response = await fetch(
      `${URLS.mainSiteBackend}/users/by-department/${department}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        // credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      console.log(response.message);
      throw new Error(response.message);
    }
    const { data } = await response.json();

    const res = data?.users?.map((el) => ({
      value: el?.Staff_ID,
      label: el?.Name,
    }));

    setState((el) => ({
      ...el,
      users: [{ value: "", label: "Select Recipient" }, ...res],
    }));
  };

  const onChangeInputs = (e) => {
    const { name, value } = e.target;
    setState((el) => ({
      ...el,
      [name]: value,
    }));
  };

  const updateAmount = (value) => {
    setState((el) => ({
      ...el,
      Amount: value,
    }));
  };

  const submit = (e) => {
    e.preventDefault();
    setState((el) => ({
      ...el,
      buttonText: "Submitting ...",
      isWaiting: true,
    }));
    const {
      applyDate,
      title,
      description,
      comment,
      Amount,
      staff,
      employee,
      requester,
    } = state;

    if (Object.entries(employee).length < 1) {
      return toast.error("Please select an employee", {
        position: "top-right",
      });
    }

    const employeeName = JSON.parse(employee).name;
    const employeeId = JSON.parse(employee).id;

    const requsion = {
      title,
      description,
      type: "Loan",
      amount: Amount,
      requestto: staff,
      status: "Pending",
      regdate: moment(new Date()).format("YYYY-MM-DD"),
      requestby: requester ? requester : staff,
      vendor: "",
      comment,
      filledFormData: "",
      loanDetails: JSON.stringify({ employeeName, employeeId }),
    };

    const formData = new FormData();
    // eslint-disable-next-line no-unused-vars
    for (const [key, value] of Object.entries(requsion)) {
      formData.append(key, value);
    }
    // console.log(requsion);
    const token = "dummy token";

    fetch(`${URLS.backendLoan}/check/${employeeId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    }).then((z) => {
      if (z?.status === 500) {
        z.json().then((x) => {
          setState((el) => ({ ...el, buttonText: "Submit", isWaiting: false }));
          toast(x.message, {
            type: "error",
            position: "top-right",
          });
        });

        return;
      }

      if (process.env.REACT_APP_HAS_INVEX === "true") {
        fetch(`${URLS.mainSiteBackend}/requisition/create`, {
          method: "POST",
          // credentials: "include",
          headers: {
            Authorization: `Token ${token}`,
          },
          body: formData,
        }).then((res) => {
          if (res.ok) {
            res.json().then((result) => {
              // console.log(result);
              fetch(`${URLS.backendLoan}`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Token ${token}`,
                },
                body: JSON.stringify({
                  Title: title,
                  Amount,
                  applyDate,
                  status: "Pending",
                  paymentsStatus: "Not paid",
                  userID: employeeId,
                  staff,
                  requestid: result?.data?.requisition?.requestid,
                  description,
                  comment,
                  branch_id,
                }),
              }).then((el) => {
                if (el.ok) {
                  el.json().then((response) => {
                    // console.log(response);

                    toast("Loan Successfully Applied.", {
                      type: "success",
                      position: "top-right",
                    });

                    setState((el) => ({
                      ...el,
                      buttonText: "Submit",
                      isWaiting: false,
                      staff: "",
                      departments: [],
                      users: [],
                      comment: "",
                      appliedDate: "",
                      title: "",
                      description: "",
                      Amount: 0,
                      userId: "",
                      employee: {},
                      employees: [],
                    }));

                    refresh && refresh();
                    onHide && onHide();
                  });
                } else {
                  el.json().then((json) => {
                    console.log(json);

                    toast("Error occurred, Check the form again.", {
                      type: "error",
                      position: "top-right",
                    });
                    setState((el) => ({
                      ...el,
                      buttonText: "Submit",
                      isWaiting: false,
                    }));
                  });
                }
              });
            });
          } else {
            res.json().then((responseJson) => {
              console.log(responseJson);
              toast("Error occurred, Check the form again.", {
                type: "error",
                position: "top-right",
              });
              setState((el) => ({
                ...el,
                buttonText: "Submit",
                isWaiting: false,
              }));
            });
          }
        });
      } else {
        return alert("Please activate accountant module to use Loan");
      }
    });
  };

  const getEmployeeFromInvex = (id) => {
    fetch(`${URLS.backendEmployees}/get-employee-from-invex-details/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setState((el) => ({
            ...el,
            requester: data?.invexStaff?.Staff_ID,
          }));
        }
      });
  };

  const {
    departments,
    users,
    Amount,
    staff,
    buttonText,
    title,
    description,
    comment,
    isWaiting,
    employees,
    employee,
    supervisor,
    isLoading,
  } = state;

  return (
    <div>
      <Modal
        show={show}
        onHide={onHide}
        dialogClassName="requisition-details-modal"
        backdropClassName={`global-backdrop`}
        centered={true}
        animation={false}
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h1>Apply Loan</h1>
            <p></p>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={submit}>
            <Form.Group className="mb-3">
              <Form.Label>
                Employee <span className="text-danger">*</span> :
              </Form.Label>

              <Select
                closeMenuOnSelect={true}
                isSearchable
                required
                classNamePrefix="form-control"
                value={employees?.find((el) => el.value === employee?.name)}
                onChange={(selected) => {
                  setState((el) => ({ ...el, employee: selected.value }));
                  getSupervisors(JSON.parse(selected.value).id); // eslint-disable-line
                  getEmployeeFromInvex(JSON.parse(selected.value).id);
                }}
                options={employees}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Title <span className="text-danger">*</span> :
              </Form.Label>
              <Form.Control
                name="title"
                placeholder="Enter a title"
                value={title}
                onChange={onChangeInputs}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Description <span className="text-danger">*</span> :
              </Form.Label>
              <label className="border p-0 rounded pb-2 message-area d-block">
                <Form.Control
                  name="description"
                  value={description}
                  onChange={onChangeInputs}
                  as="textarea"
                  className="w-100 border-0 p-3"
                  placeholder="Enter your detail description"
                  rows={4}
                  required
                />
              </label>
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label>
                Loan Amount <span className="text-danger">*</span> :
              </Form.Label>

              <CurrencyInput
                className="form-control"
                value={Amount}
                allowNegativeValue={false}
                // allowDecimals={false}
                onValueChange={(value, name) => updateAmount(value)}
              />
            </Form.Group>

            <div className="d-flex align-items-center my-4">
              <h4 className="pr-2">Send Request To</h4>{" "}
              <hr className="flex-grow-1 m-0" />
            </div>

            {!supervisor ? (
              <div className="row gap-3">
                <Form.Group className="col mb-3">
                  <Form.Label>
                    Department <span className="text-danger">*</span> :
                  </Form.Label>
                  <Select
                    classNamePrefix={`form-select-analytics`}
                    isSearchable={true}
                    placeholder="Select Recipient's Department"
                    options={departments}
                    // value={departments?.find(
                    //   (el) => el.value === queryParams.by
                    // )}
                    onChange={(selected) => {
                      getUsersInDepartments(selected?.value);
                    }}
                  />
                </Form.Group>

                {users?.length > 0 ? (
                  <Form.Group className="col mb-3">
                    <Form.Label>
                      Recipient <span className="text-danger">*</span> :
                    </Form.Label>
                    <Select
                      classNamePrefix={`form-select-analytics`}
                      isSearchable={true}
                      placeholder="Select Recipient"
                      options={users}
                      // value={departments?.find(
                      //   (el) => el.value === queryParams.by
                      // )}
                      onChange={(selected) => {
                        const e = {
                          target: { name: "staff", value: selected?.value },
                        };
                        onChangeInputs(e);
                      }}
                    />
                  </Form.Group>
                ) : null}
              </div>
            ) : (
              <div className="my-3">
                <input
                  className="form-control"
                  disabled
                  type="text"
                  value={supervisor?.Name}
                />
              </div>
            )}
            <Form.Group className="mb-3">
              <Form.Label>Comment :</Form.Label>
              <label className="border p-0 rounded pb-2 message-area d-block">
                <Form.Control
                  name="comment"
                  value={comment}
                  onChange={onChangeInputs}
                  as="textarea"
                  className="w-100 border-0 p-3"
                  placeholder="Enter a comment"
                  rows={4}
                />
              </label>
            </Form.Group>
            <div className="submit-section">
              <button
                className="btn btn-primary submit-btn"
                disabled={isWaiting}
              >
                {buttonText}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <ModalLoader show={isLoading} />
    </div>
  );
}
